import type { ReactNode } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useRef } from 'react';

interface DropdownItem {
  to: string;
  label: string;
}

interface NavItemDropdownProps {
  icon: ReactNode;
  label: string;
  items: DropdownItem[];
}

export function NavItemDropdown({ icon, label, items }: NavItemDropdownProps) {
  const location = useLocation();
  const isActive = items.some((item) => location.pathname === item.to);
  const dropdownRef = useRef<HTMLLIElement>(null);

  const handleItemClick = () => {
    const dropdownMenu = dropdownRef.current?.querySelector('.dropdown-menu');
    const dropdownToggle = dropdownRef.current?.querySelector('.dropdown-toggle');

    if (dropdownMenu && dropdownToggle) {
      dropdownMenu.classList.remove('show');
      dropdownToggle.classList.remove('show');
      dropdownToggle.setAttribute('aria-expanded', 'false');
    }
  };

  return (
    <li className={isActive ? 'nav-item dropdown active' : 'nav-item dropdown'} ref={dropdownRef}>
      <a className="nav-link dropdown-toggle" href="#navbar-dropdown" data-bs-toggle="dropdown" role="button" aria-expanded="false">
        <span className="nav-link-icon d-md-none d-lg-inline-block">{icon}</span>
        <span className="nav-link-title">{label}</span>
      </a>
      <div className="dropdown-menu">
        {items.map((item) => (
          <NavLink key={item.to} to={item.to} className="dropdown-item" onClick={handleItemClick} end>
            {item.label}
          </NavLink>
        ))}
      </div>
    </li>
  );
}
